import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StrollerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stroller"}/>
}
